export default __webpack_public_path__ + "static/media/book-read-user.cfef2524.svg";